import { el } from "@dhx/ts-common/dom";
import { GridEvents, ICell, ICellRect, IGrid, ISelection, IRow, ICol, ISelectionType } from "./types";
import { DataEvents } from "@dhx/ts-data";

export class Selection implements ISelection {
	protected _grid: IGrid;
	protected _selectedCell: ICell;
	protected _cellRect: ICellRect;
	protected _type: ISelectionType;
	protected _outerClick: <T>(e: MouseEvent) => void;
	constructor(grid: IGrid) {
		this._grid = grid;
		const types = ["cell", "row", "complex"];
		this._type = types.indexOf(this._grid.config.selection) !== -1 ? this._grid.config.selection : "complex";
		this._init();
	}
	destructor() {
		document.removeEventListener("click", this._outerClick);
	}
	setCell(row?: any, col?: any) {
		if (!this._grid.config.$editable) {
			if (!row) {
				this._selectedCell = undefined;
			} else {
				row = row.id ? row : this._grid.data.getItem(row);
				if (!col) {
					col = this._grid.config.columns[0];
				}
				col = col.id ? col : this._grid.getColumn(col);
				this._selectedCell = { row, column: col };
			}
			this._grid.paint();
		}
	}
	getCell(): ICell {
		return this._selectedCell;
	}
	toHTML() {
		if (!this._selectedCell || !this._selectedCell.row || !this._selectedCell.column) {
			return;
		}
		const fixedCols = this._grid.config.splitAt ?
			this._grid.config.columns.slice(0, this._grid.config.splitAt) : [];
		const fixedColsIds = fixedCols.map(col => col.id);

		let fixedCell: any;

		const cellRect = this._grid.getCellRect(this._selectedCell.row.id, this._selectedCell.column.id);
		if (fixedColsIds.indexOf(this._selectedCell.column.id) !== -1) {
			const scrollState = this._grid.getScrollState();
			fixedCell = el(".dhx_grid-selected-cell", {
				style: {
					width: (this._grid.config.splitAt === fixedColsIds.indexOf(this._selectedCell.column.id) + 1) ? cellRect.width - 1 : cellRect.width,
					height: cellRect.height,
					top: cellRect.y,
					left: cellRect.x + scrollState.x,
					position: "absolute",
					zIndex: 10
				}
			});
		}

		const totalWidth = this._grid.config.$totalWidth;

		return el(".dhx_grid-selection", {}, [
			(this._type === "row" || this._type === "complex") && el(".dhx_grid-selected-row", {
				style: {
					width: totalWidth,
					height: cellRect.height - 1,
					top: cellRect.y,
					left: 0,
					position: "absolute"
				}
			}),
			((this._type === "cell" || this._type === "complex") && fixedCell) ||
			((this._type === "cell" || this._type === "complex") && el(".dhx_grid-selected-cell", {
				style: {
					width: cellRect.width,
					height: cellRect.height - 1,
					top: cellRect.y,
					left: cellRect.x,
					position: "absolute"
				}
			}))
		]);
	}
	protected _init() {
		this._grid.events.on(GridEvents.cellClick, (row: IRow, col: ICol) => {
			this.setCell(row,col);
		});

		this._grid.data.events.on(DataEvents.beforeRemove, item => {
			if (item && this._selectedCell && this._selectedCell.row) {
				const index = this._grid.data.getIndex(String(this._selectedCell.row.id));
				const id = this._grid.data.getId(index + 1);
				if (id) {
					this.setCell(id);
				} else {
					const newId = this._grid.data.getId(index - 1);
					if (newId) {
						this.setCell(newId);
					}
				}
				this._grid.paint();
			}
		});

		this._outerClick = (e: MouseEvent) => {
			if (!this._grid.config.$editable) {
				const rootNode = this._grid.getRootView().data.getRootNode();
				let target = e.target;
				let check = false;
				while (target) {
					if (target === rootNode) {
						check = true;
						return;
					}
					target = (target as any).parentNode;
				}
				if (!check && this._selectedCell) {
					this.setCell();
				}
			}
		};
		document.addEventListener("click", this._outerClick);
	}
}